<ng-container *ngIf="loading">
  <mapfre-loading></mapfre-loading>
</ng-container>
<ng-container *ngIf="!loading">
  <header class="row margin-bottom mb24">
    <div class="col">
      <h1 class="claims-title">
        {{ "CLAIMS" | translate }}
      </h1>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="2" viewBox="0 0 842 2" fill="none">
        <path d="M0 1H842" stroke="#CCCCCC"/>
      </svg>
    </div>
  </header>
  <section class="claim-detail-exposures claim-detail-sections">
    <section class="claim-details-left" [ngClass]="{'no-right-bdr':claims.length === 0}"  >
      <ng-container *ngIf="isAvailable; else showApp">
        <div class="col1 col">
          <div class="maintenance-sorry-page-document">
            <div class="head margin-bottom mb24">
              {{ "MAINTENANCE_CLAIMS" | translate }}
            </div>

            <div class="inprogress margin-bottom mb24">
              {{ "MAINTENANCE_INPROGRESS_1" | translate }}
              <div>
                {{ "MAINTENANCE_INPROGRESS_2" | translate }}
              </div>
            </div>

            <div class="inprogress margin-bottom mb24">
              <b>{{ "MAINTENANCE_TIME" | translate }}</b>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #showApp>
        <div class="claims-list claim-home-list">
          <ng-container *ngIf="claims.length; else noclaims">
            <ng-container *ngFor="let claim of claims">
              <app-claims-home-car [claim]="claim"></app-claims-home-car>              
            </ng-container>
          </ng-container>
        </div>
      </ng-template>
    </section>
    <section class="claim-details-right" *ngIf="claims.length">
      <div class="row claims-faq mb-4">
        <div class="col">
          <app-claims-report></app-claims-report>
        </div>
      </div>
      <div *ngIf="!isAcmic && isMA" class="row claims-faq mb-4">
        <div class="col">
          <app-claims-need-help></app-claims-need-help>
        </div>
      </div>
      <div class="row claims-faq d-none">
        <div class="col">
          <app-claims-accordian-faq></app-claims-accordian-faq>
        </div>
      </div>
    </section>
  </section>
  <ng-template #noclaims>
    <app-no-claims></app-no-claims>
  </ng-template>
</ng-container>
